import comp from './ApproveActionBar'
export default comp;